<template>
  <nav class="nav" :class="{ 'nav-mobile': mobileMode }">
    <section v-if="mobileMode" class="mobile-items">
      <span class="menu-item" @click="goHome">
        <img src="../../images/icons/home-sm.svg" style="margin-right: 8px;" />
        Home
      </span>
    </section>

    <section class="top">
      <section v-if="hasArchives">
        <span
          v-for="archive in fileStoreStore.archives"
          :key="archive.archiveId"
        >
          <span v-if="archive.isDisabled" class="menu-item has-path disabled">
            <inline-svg src="/images/icons/archive-sm.svg"></inline-svg>
            <span>{{ archive.name }}</span>
          </span>
          <router-link
            v-else
            :to="{
              name: 'fileStoreFolder',
              params: { archiveId: archive.archiveId, folderId: archive.id }
            }"
            class="menu-item has-path"
          >
            <inline-svg src="/images/icons/archive-sm.svg"></inline-svg>
            <span>{{ archive.name }}</span>
          </router-link>
        </span>
      </section>
    </section>
    <!-- existing archives -->

    <!-- dashboard link etc at bottom -->
    <section class="bottom">
      <router-link
        :to="{ name: 'fileStoreDashboard' }"
        class="menu-item has-path"
        ><inline-svg src="/images/icons/dashboard.svg"></inline-svg>
        Dashboard
      </router-link>
      <!--  <button @click="viewOrders" class="menu-item has-fill">
        <inline-svg src="/images/icons/printer-sm.svg"></inline-svg
        >Opdrachten
      </button> -->
      <router-link
        :to="{ name: 'fileStoreTrashArchiveList' }"
        class="menu-item has-fill"
        ><inline-svg src="/images/icons/trash.svg"></inline-svg>Prullenmand
      </router-link>
    </section>
  </nav>
</template>

<script>
import { mapStores } from 'pinia'
import { useFileStoreStore } from '@/features/filestore/FileStore.store'
import { EventBus } from '@/eventbus/EventBus'

export default {
  props: {
    mobileMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapStores(useFileStoreStore),
    hasArchives() {
      return this.fileStoreStore.archives?.length > 0
    }
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'home' })
    },
    newArchive() {
      EventBus.emit('createNewArchive')
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../sass/helpers/_variables.scss' as *;
@use '../../sass/base/_colors.scss' as *;

.nav {
  position: relative;
  height: 100%;
  //max-height: 614px;
  overflow: hidden;
  background-color: white;
  display: flex;
  flex-direction: column;

  &.nav-mobile {
    width: 200px;
    height: 100vh;
    overflow: auto;
    z-index: 20;
  }

  .mobile-items {
    border-bottom: solid 1px $fs-divider;
  }
  .top {
    overflow: auto;
    flex-grow: 1;
    padding-top: 5px;

    .menu-item {
      padding-left: 14px;
    }
  }

  .bottom {
    background-color: #f7f7f7;
    border-radius: 14px;
    margin-left: 4px;
    margin-bottom: 4px;
    margin-right: 4px;

    button {
      font-size: 0.8rem;
    }
  }

  .menu-item {
    padding: 10px;
    display: flex;
    align-items: center;
    text-decoration: none;
    color: $text-color;
    font-weight: 500;
    height: 44px;
    cursor: pointer;
    transition: color 0.3s;

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: normal;
    }

    /*  &.has-fill {
      path {
        fill: var(--sub-color);
      }
    } */

    &.disabled {
      color: #bbb;
    }

    &:hover {
      color: var(--sub-color);

      &.disabled {
        color: #bbb;
      }
    }

    &.router-link-active {
      color: var(--sub-color);
      font-weight: 500;

      &.has-path {
        path {
          stroke: var(--sub-color);
        }
      }

      &.has-fill {
        path {
          fill: var(--sub-color);
        }
      }
    }

    svg {
      margin-right: 8px;
      min-width: 15px;
    }
  }
}
</style>
